/**
 * Created by lzy 19-11-03
 * 百家号新建稿件
 */
'use strict';
angular.module('editQiehaoToBeCompiledVideoModule', []).controller('editingCenterQiehaoVideoCtrl', [
    '$scope',
    'beforeonload',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$validation',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'jsonArrayToStringService',
    'trsspliceString',
    'editingCenterService',
    'storageListenerService',
    'iWoService',
    'globleParamsSet',
    'editPictureService',
    'editCenUploadVideoForXjService',
    'qiehaoService',
    'editingMediatype',
    'newMediaService',
    'qieConst',
    'editIsLock',
    'messagePublishService',
    function (
        $scope,
        beforeonload,
        $element,
        $compile,
        $q,
        $state,
        $validation,
        $timeout,
        trsHttpService,
        modalDialog,
        jsonArrayToStringService,
        trsspliceString,
        editingCenterService,
        storageListenerService,
        iWoService,
        globleParamsSet,
        editPictureService,
        editCenUploadVideoForXjService,
        qiehaoService,
        editingMediatype,
        newMediaService,
        qieConst,
        editIsLock,
        messagePublishService
    ) {
        initStatus();
        initData();
        qiehaoService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                // 判断是否显示校验
                showCheckList: [false, false],
                support: {
                    content: '',
                },
                qiehaoFormError: [],
                switch: 'manuscriptInfo',
                isOriginal: $state.params.isOriginal,
                progressss: 0,
                topAttachFilePicSize: '16,9',
                isFusionEditor: $state.current.name == 'fusionvideo', // 是否来自融合编辑器
                isEditDraft: !!$state.params.qiehaoarticleid,
                accurateLabel: '',
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                mediaType: editingMediatype.qiehao,
                qiehaoarticleid: $state.params.qiehaoarticleid,
            };
            $scope.data = {
                scaleImgSize: globleParamsSet.scaleImgSize(),
                articleClass: {},
                LABEL: [],
                version: [], // 流程展示数据
                copyVersion: [],
                trench: qieConst.listenStroageKey,
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.uploader = {
                example: '',
                progress: 0,
                fastVideoTimer: '',
                canNotPlay: false,
                fastVideoInfo: {}, // 视频快编信息
                uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
            };
            $scope.editFlag = {
                media: 'qiehao', 
                docType: 'video',
            };
        }

        /** **************************适应融合编辑器切换渠道开始**************************/
        /**
         * [initData description]初始化数据
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]
         * @return  {[type]}                   [return description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if (angular.isDefined($state.params.qiehaoarticleid)) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /** **************************适应融合编辑器切换渠道结束**************************/
        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                initArrayBtn();
                ($state.params.qiehaoarticleid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
        }

        /**
         * [initNewData description]初始化新稿件
         * @param   {[Function]}  dealWithListFun  [dealWithListFun description]传入的方法
         * @return  {[type]}                   [return description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = {
                serviceid: 'mlf_kuaibaoarticle',
                methodName: 'saveVideoDoc',
                ARTICLEID: $state.params.qiehaoarticleid || 0,
                ACCOUNTID: $state.params.qiehaoaccount,
                TITLE: '',
                VIDEOURL: '',
                HTMLCONTENT: '',
                FGD_EDITINFO: [],
                FGD_AUTHINFO: [{ isCreate: true }],
                ORIGINAL: 0,
                SPECIALDOC: 0,
                VIDEOREL: [],
                COVERTYPE: 1,
                COVERLIST: [],
                ISNOPAYMENT: '1'
            };
            loadDirective();
            initDocgenre();
            getClass();
            // 融合编辑器下转码list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initNewData description]初始化编辑稿件
         * @param   {[Function]}  dealWithListFun  [dealWithListFun description]传入的方法
         * @return  {[type]}                   [return description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_kuaibaoarticle',
                methodName: 'getDocs',
                ArticleId: $state.params.qiehaoarticleid,
            };
            // 适应融合编辑
            if ($scope.status.isFusionEditor) {
                params = {
                    serviceid: 'mlf_fusionkuaibao',
                    methodname: 'getKuaiBaoVirtualDoc',
                    SourceDocId: $state.params.iwometadataid,
                };
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                $scope.list.TOPATTACHFILE = [];
                $scope.list.COVERLIST = $scope.list.COVERLIST ? $scope.list.COVERLIST : [];
                $scope.list.serviceid = 'mlf_kuaibaoarticle';
                $scope.list.methodName = 'saveVideoDoc';
                $scope.status.videoStatus = true;
                loadDirective();
                initDocgenre($scope.list);
                getClass();
                initLabel();
                showVersion();
                // 融合编辑下转码list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.qiehaoarticleid);
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initDocgenre description] 初始化稿件体裁
         * @param   {[type]}  obj  [obj description]
         * @return  {[type]}       [return description]
         */
        function initDocgenre(obj) {
            iWoService.initData().then(function (data) {
                $scope.data.docgenre = data.DocGenre;
                $scope.list.DOCGENRE = obj ? obj.DOCGENRE : angular.copy($scope.data.docgenre[0]);
            });
        }

        /**
         * [getAttachFileData description] 初始化封面图
         * @param   {[type]}  picData  [picData description]
         * @param   {[type]}  picType  [picType description]
         *
         * @return  {[type]}           [return description]
         */
        function getAttachFileData(picData, picType) {
            return [
                {
                    APPFILE: picData.imgName || picData.APPFILE,
                    APPDESC: picData.imgName || picData.APPDESC,
                    PERPICURL: picData.imgSrc || picData.PERPICURL,
                    TOPPIC: picType,
                },
            ];
        }

        /**
         * [getPicDataInit description] 获取头条封面
         * @param   {[type]}  picData  [picData description]
         * @return  {[type]}           [return description]
         */
        function getPicDataInit(picData) {
            if ($scope.list.TOPATTACHFILE.length === 0) {
                $scope.list.TOPATTACHFILE = getAttachFileData(picData, '1');
            }
        }

        /**
         * [getPropagandaReview description] 宣传部送审流程
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview($scope.status.mediaType, $state.params.qiehaoarticleid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [picCallbackData description] 点击获取封面图的回调
         * @return {[type]} [description]
         */
        $scope.picCallbackData = function () {
            var picresize;
            if ($scope.list.TOPATTACHFILE.length === 1) {
                modalDialog.alertType('列表图已填充满', '', 'warning', false);
                return;
            }
            if ($scope.list.TOPATTACHFILE.length === 0) {
                picresize = $scope.status.topAttachFilePicSize;
            }
            return function (fileName) {
                editPictureService.newCropperApp(fileName, picresize).then(
                    function (src) {
                        getPicDataInit(src);
                    },
                    function () { }
                );
            };
        };

        /**
         * [loadDirective description]动态加载指令
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var videoUpload = '<div trs-upload-for-xj-video-draft list="list" storage-type="qiehao" metadata="qiehaoarticleid"></div>';
            videoUpload = $compile(videoUpload)($scope);
            $element.find('videocon').append(videoUpload);
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="qehVideoForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        }

        /* 稿件操作开始*/
        /**
         * [save description] 保存稿件
         * @param {[type]} [flag] [description] 是否为操作前的保存
         * @return {[type]} [description]
         */
        $scope.save = function () {
            var defer = $q.defer();
            editCenUploadVideoForXjService.exampleVideoBeforeSave($scope).then(() => {
                saveList(true).then(
                    function () {
                        storageListenerService.addListenerToQiehao('save');
                        $scope.status.isEditDraft = true;
                        // $state.params = angular.copy($state.params);
                        $state.transitionTo($state.current, $state.params, {
                            reload: false,
                        });
                        // 保存
                        showVersion();
                        if (!$scope.status.isFusionEditor) {
                            $timeout(function () {
                                modalDialog.saveModel('保存成功', '', 'success');
                            }, 500);
                        }
                        defer.resolve();
                    },
                    function (msg) {
                        defer.reject(msg);
                    }
                );
            }, () => {
                defer.reject({
                    plat: '企鹅号'
                });
            });
            return defer.promise;
        };

        /**
         * [saveList description] 切换时保存list数据
         * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果关闭页面则不加锁，不关闭则加锁
         * @return  {[type]}        [return description]
         */
        function saveList(flag) {
            var defer = $q.defer();
            // 转码发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                $scope.list.serviceid = 'mlf_fusionkuaibao';
                $scope.list.methodName = 'saveKuaiBaoVirtualDoc';
                $scope.list.SourceDocId = $scope.data.sourceDocId || $state.params.qiehaoarticleid;
                $scope.list.FusionKuaiBaoId = $state.params.qiehaoarticleid || '0';
                $scope.list.DocType = 7; // 表示视频稿
            }
            $scope.qehVideoForm.$pending = {};
            $validation
                .validate($scope.qehVideoForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        true,
                        function () {
                            var list = angular.copy($scope.list);
                            list.ARTICLECLASSIFICATION = $scope.data.articleClass.ARTICLECLASSIFICATIONID;
                            list.LABEL = trsspliceString.spliceString(angular.copy($scope.data.LABEL), 'name', ',');
                            list.ORIGINALTYPE = $scope.data.originType;
                            list.SPECIALDOC = $scope.data.specialDoc;
                            list.ARTICLEID = $state.params.qiehaoarticleid || '0';
                            list = jsonArrayToStringService.jsonArrayToString(list);
                            $scope.qehVideoForm.$setPristine();
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                $state.params.qiehaoarticleid = $scope.list.qiehaoarticleid = data.METADATAID.replace(/\"/g, ''); // 后台返回的是字符串，需要转成数字类型
                                beforeonload.refresh($scope);
                                //  稿件加锁
                                if (flag) {
                                    editIsLock.lockDraft($state.params.qiehaoarticleid);
                                }
                                editCenUploadVideoForXjService.clearDraftVideoInfo('qiehao', 'qiehaoarticleid');
                                defer.resolve();
                            });
                        },
                        function () {
                            defer.reject();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.qehVideoForm, $element, $scope); // 定位输入错的表单位置
                    defer.reject({
                        plat: '企鹅号'
                    });
                });
            return defer.promise;
        }

        /**
         * [initArrayBtn description]初始化按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            qiehaoService.initEditerBtn($state.params.qiehaoplatform, $state.params.qiehaoaccount).then(function(data) {
                $scope.arrayBtn = data;
            });
        }

        /**
         * [qiehaoTrial description]送审操作
         * @return {[type]} [description]
         */
        $scope.qiehaoTrial = function () {
            newMediaService.trial($scope, qieConst.trial).then((opinion) => {
                saveList().then(function () {
                    let qieParams = angular.extend({ objectids: $state.params.qiehaoarticleid, accountId: $state.params.qiehaoaccount, opinion: opinion}, qieConst.trial);
                    messagePublishService.publish('doEditPageOperation', qieParams);
                });
            });
        };

        /*
         *撤稿操作
         */
        $scope.qiehaoKill = function () {
            newMediaService.rejection($scope, qieConst.rejection).then((opinion) => {
                saveList().then(function () {
                    let qieParams = angular.extend(
                        {
                            objectids: $state.params.qiehaoarticleid,
                            accountId: $state.params.qiehaoaccount,
                            opinion: opinion
                        },
                        qieConst.rejection
                    );
                    messagePublishService.publish('doEditPageOperation', qieParams);
                });
            });
        };

        /**
         * [packageReSignParams description] 组装强制签发参数
         * @param   {[type]}  params         [params description]
         * @param   {[type]}  selectedArray  [selectedArray description]
         * @return  {[type]}                 [return description]
         */
        function packageReSignParams(params, selectedArray){
            params.objectids = selectedArray[0].DOC.METADATAID;
        }
        
        /**
         * [qiehaoSign description]签发操作
         * @return {[type]} [description]
         */
        $scope.qiehaoSign = function () {
            $scope.loadingPromise = newMediaService.sign($scope).then(() => {
                saveList().then(() => {
                    let signParams = angular.extend({
                        objectids: $state.params.qiehaoarticleid,
                        accountId: $state.params.qiehaoaccount
                    }, qieConst.sign);
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        };

        /**
         * [updateCKSelection description]更新稿费状态
         * @param  {[obj]} list [description]稿件对象
         * @return {[type]}     [description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
        };

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.qehVideoForm.$error) {
                errorArray.push(error);
            }
            $scope.status.videoFormError = $scope.status.videoFormError == undefined ? [] : $scope.status.videoFormError;
            if ($scope.status.videoFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.videoFormError = errorArray;
            }
            return $scope.status.videoFormError; // 返回
        };

        /**
         * [deleteUploaderImg description]删除上传后的图片
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function () {
            $scope.list.COVERLIST = [];
        };
        // 裁剪完图片后压缩
        $scope.scaleImg = function (src) {
            var params = {
                FILENAME: src.imgName,
                FOLDEREXT: 'W0',
                SCALEHEIGHT: $scope.data.scaleImgSize.scaleHeight,
                SCALEWIDTH: $scope.data.scaleImgSize.scaleWidth,
                methodname: 'scaleImage',
                serviceid: 'mlf_image',
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function (data) {
                $scope.list.COVERLIST[0].IMAGENAME = data.FN;
                $scope.list.COVERLIST[0].IMAGEURL = '/wcm/file/read_image.jsp?FileName=' + data.FN;
            });
        };

        /**
         * [getClass description]获取文章分类
         * @return  {[type]}  [return description]
         */
        function getClass() {
            $scope.loadingPromise = qiehaoService.getArticleClass(7).then(function (data) {
                data.unshift({
                    CLASSTEXT: '请选择文章分类',
                    ARTICLECLASSIFICATIONID: '',
                });
                $scope.data.articleClassArr = data;
                if (!$scope.list.ARTICLECLASSIFICATION || $scope.list.ARTICLECLASSIFICATION === '0') {
                    $scope.data.articleClass = data[0];
                    return;
                }
                for (var i = 0, len = data.length; i < len; i++) {
                    if ($scope.list.ARTICLECLASSIFICATION == data[i].ARTICLECLASSIFICATIONID) {
                        $scope.data.articleClass = data[i];
                        break;
                    }
                }
            });
        }
        // 标签方法
        /**
         * [initKeyWords description]初始化关键词
         * @return {[type]} [description]
         */
        function initLabel() {
            if ($scope.list.LABEL) {
                var LABEL = $scope.list.LABEL.split(',');
                $scope.data.LABEL = [];
                angular.forEach(LABEL, function (data, index, array) {
                    $scope.data.LABEL.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.LABEL = [];
            }
        }
        $scope.checkTag = function (tag) {
            var len = $scope.data.LABEL.length;
            if (len == 5) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '标签个数不能超过5个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.label.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.label.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.label.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function () {
            // $scope.isShowKeywordTips = false;
        };
        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 8) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个标签长度不能超过8！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };

        /**
         * [revise description] 修订操作
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                saveList().then(function (data) {
                    var params = {
                        MediaType: $scope.status.mediaType,
                    };
                    $scope.loadingPromise = editingCenterService.reviseFinished(params);
                });
            });
        };

        /**
         * [showVersion description] 判断是融合编辑下的获取版本记录还是渠道内的获取版本记录
         * @return  {[type]}  [return description]
         */
        function showVersion() {
            if ($scope.status.isFusionEditor) {
                getFusionVersion();
            } else {
                getVersion();
                getPropagandaReview();
            }
        }

        /**
         * [getVersion description] 获取流程记录
         * @return  {[type]}  [return description]
         */
        function getVersion() {
            newMediaService.getVersion($state.params.qiehaoarticleid).then(function (data) {
                $scope.data.records = data;
            });
        }

        /**
         * [getVersion description] 获取融合编辑流程记录
         * @return {[type]} [description]
         */
        function getFusionVersion() {
            var deffer = $q.defer();
            editingCenterService.getEditVersionTime($scope.data.sourceDocId || $state.params.iwometadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deffer.resolve();
                },
                function () {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getFusionVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            newMediaService.openPersonalVersionTime($state.params.iwometadataid, item);
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        $scope.closeCurrView = function() {
            qiehaoService.qiehaoUnlock($scope.qehVideoForm, $state.params.qiehaoarticleid, saveList, $scope.list);
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, {typeName: 'qiehao', saveLocal: false});
        }
    },
]);
